import { Box, Typography, Card, CardActionArea } from "@mui/material";
import { motion } from "framer-motion";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useTranslation } from "react-i18next";

import MovieIcon from "@mui/icons-material/Movie";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import MicIcon from "@mui/icons-material/Mic";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import CampaignIcon from "@mui/icons-material/Campaign";
import PublicIcon from "@mui/icons-material/Public";
import StyleIcon from "@mui/icons-material/Style";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import TheaterComedyIcon from "@mui/icons-material/TheaterComedy";
import { useNavigate } from "react-router-dom";
import img from "../../images/categories/actors.jpeg";
import writer from "../../images/categories/writers.jpeg";
import music from "../../images/categories/music.jpeg";
import comedy from "../../images/categories/comedy.jpeg";
import sports from "../../images/categories/sports.jpeg";
import pub from "../../images/categories/publish.jpeg";
import gaming from "../../images/categories/gaming.png";
import digital from "../../images/categories/digital.png";
import end from "../../images/categories/ends.png";
import fashion from "../../images/categories/fashion.jpeg";
import media from "../../images/categories/media.jpeg";
import news from "../../images/categories/news.jpeg";
import theatre from "../../images/categories/theatre.jpeg";

const MotionCard = motion(Card);

const categories = [
  {
    id: "actors",
    key: "actors",
    icon: <MovieIcon />,
    image: img,
  },
  {
    id: "writers",
    key: "writers",
    icon: <MovieIcon />,
    image: writer,
  },
  {
    id: "music",
    key: "music",
    icon: <MusicNoteIcon />,
    image: music,
  },
  {
    id: "sports",
    key: "sports",
    icon: <SportsSoccerIcon />,
    image: sports,
  },
  {
    id: "comedy",
    key: "comedy",
    icon: <MicIcon />,
    image: comedy,
  },
  {
    id: "publishing",
    key: "publishing",
    icon: <MenuBookIcon />,
    image: pub,
  },
  {
    id: "gaming",
    key: "gaming",
    icon: <SportsEsportsIcon />,
    image: gaming,
  },
  {
    id: "endorsements",
    key: "endorsements",
    icon: <CampaignIcon />,
    image: end,
  },
  {
    id: "digital",
    key: "digital",
    icon: <PublicIcon />,
    image: digital,
  },
  {
    id: "media",
    key: "media",
    icon: <PublicIcon />,
    image: media,
  },
  {
    id: "fashion",
    key: "fashion",
    icon: <StyleIcon />,
    image: fashion,
  },
  {
    id: "news",
    key: "news",
    icon: <NewspaperIcon />,
    image: news,
  },
  {
    id: "theatre",
    key: "theatre",
    icon: <TheaterComedyIcon />,
    image: theatre,
  },
];

export default function RepresentationCategories() {
  const navigate = useNavigate();
  const { t } = useTranslation("representations");

  return (
    <Box
      sx={{
        maxWidth: 1400,
        mx: "auto",
        px: { xs: 3, md: 8 },
        py: { xs: 8, md: 14 },
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          md: "repeat(auto-fill, minmax(360px, 1fr))",
        },
        gap: 5,
      }}
    >
      {categories.map((cat, index) => (
        <MotionCard
          key={cat.key}
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{
            duration: 0.7,
            ease: "easeOut",
            delay: index * 0.05,
          }}
          sx={{
            borderRadius: 4,
            overflow: "hidden",
            backgroundColor: "#fff",
            boxShadow: "0 30px 60px rgba(0,0,0,0.08)",
          }}
        >
          <CardActionArea
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
            }}
            onClick={() => navigate(`/services/${cat.id}`)}
          >
            {/* Image */}
            <Box sx={{ height: 220, position: "relative" }}>
              <LazyLoadImage
                src={cat.image}
                alt={t(`categories.${cat.key}`)}
                effect="blur"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            </Box>

            {/* Text */}
            <Box
              sx={{
                p: 3,
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <Box
                sx={{
                  color: "#B89E5A",
                  fontSize: "1.8rem",
                }}
              >
                {cat.icon}
              </Box>

              <Typography
                sx={{
                  fontFamily: "Playfair Display",
                  fontSize: "1.35rem",
                  fontWeight: 600,
                  letterSpacing: "0.02em",
                }}
              >
                {t(`categories.${cat.key}`)}
              </Typography>
            </Box>
          </CardActionArea>
        </MotionCard>
      ))}
    </Box>
  );
}
